/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Glyphicon } from 'react-bootstrap';

import './file-upload-file-list.css';

class FileUploadFileList extends Component {
  removeFile = (id, file) => {
    const { data, model, dispatch } = this.props;
    const index = data.map(object => Object.keys(object)[0]).indexOf(id);

    if (file.persisted !== false) {
      dispatch(actions.push(model, { [id]: { id: file.id, _destroy: true } }));
    } else {
      dispatch(actions.remove(model, index));
    }
  }

  render() {
    const { data, fileName } = this.props;
    const fileList = Object.entries(Object.assign({}, ...data)).filter(([file]) => file && file._destroy !== true);
    
    return (
      <div>
        {fileList.map(([index, file], key) => (
          <div key={key} className="list-item">
            <Glyphicon
              glyph="remove"
              className="list-item-icon"
              onClick={() => this.removeFile(index, file)}
            />
            {file.persisted ? <Link to={file.href}>{file.name}</Link> : file[fileName] ? file[fileName].name : file.name }
          </div>
        ))}
      </div>
    );
  }
}

export default connect()(FileUploadFileList);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/file-upload-file-list.jsx